// extracted by mini-css-extract-plugin
export var pill = "ad-module--pill--ode+t";
export var fadein = "ad-module--fadein--uhxDU";